import { render, staticRenderFns } from "./DoubleNumberFramePassengers.vue?vue&type=template&id=5d334a63&"
import script from "./DoubleNumberFramePassengers.vue?vue&type=script&lang=js&"
export * from "./DoubleNumberFramePassengers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports